import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import {
  redirectURLLink,
  handleQuarterFormate,
} from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import { onLoadPqasGrid } from '../../PQASTab/components/gridComponents/pqasUtils';

import {
  dispatchActiveInvoiceNumber,
  dispatchSummaryGridList,
  dispatchROSIGridList,
  setPerviousSearchPickInvReduxData,
  dispatchAllocatePaymentHederData,
  dispatchDuplicateROSIGridList,
  dispatchRsAddValuesList,
  clearReduxAllocatePaymentThirdScreen,
  deallocateNDCStore,
  setDisabledValIntPaid,
} from '../../store/Actions';
import {
  dispatchGetInvoiceHeader,
  dispatchPQASGridLevelActions,
  dispatchSaveDetailsResponse,
  getPrevNextQtrForPQAS,
} from '../../PQASTab/store/Actions';
import { tabHighLigther } from '../../../../../SharedModules/utilities/utilities';
import {
  CalculateAmountOwedNDC,
  CalculateRebateAmountInvoice,
  calculateTotalSum,
} from './tableHead';

export const getAllocatePaymentScreenData = async (
  data,
  dispatch,
  AllocatePaymentReducer,
  history,
  newObj,
  invoiceType,
  currPreNxtQtr,
  cancelPqasFlag = null
) => {
  const fetchSearchScreenData = AllocatePaymentReducer?.pervSearchScreenData;
  const searchPickInvAssociateScreenObj =
    AllocatePaymentReducer?.searchPickInvAssociateScreenObj;
  const headerAllocatePaymentData =
    AllocatePaymentReducer?.headerAllocatePaymentData;
  const ROSIGirdRowData = AllocatePaymentReducer?.ROSIGridList;
  const duplicateROSIGridList = AllocatePaymentReducer?.duplicateROSIGridList;
  const summaryGirdRowData = AllocatePaymentReducer?.summaryGridList;
  const rsAddValuesData = AllocatePaymentReducer?.rsAddValueList;
  const searchPicInvAssociationScreenTab =
    AllocatePaymentReducer?.pervSearchPickInvScreenData;
  const headerAllocatePaymentVO = data?.headerAllocatePaymentVO;
  const tempObj = headerAllocatePaymentData;
  let updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
  let checkLogNum = fetchSearchScreenData?.selectedRow?.checkLogNum;
  if (data?.windowTitle) {
    checkLogNum = data?.windowTitle?.split('Chk Log #:')[1]?.split(']')[0];
  }
  headerAllocatePaymentVO.markInterestCount = false;
  headerAllocatePaymentVO.idblmfgUB = parseFloat(data?.idblmfgUB).toFixed(2);
  headerAllocatePaymentVO.checkLogNum = checkLogNum;
  headerAllocatePaymentVO.recancilationNumber = data?.recancilationNumber;
  headerAllocatePaymentVO.reconciliationNumber = data?.recancilationNumber;
  headerAllocatePaymentVO.originalTotAllocatedAmt =
    headerAllocatePaymentVO?.totAllocatedAmt || 0;
  headerAllocatePaymentVO.oldOriginalAllocateAmt =
    headerAllocatePaymentVO?.totAllocatedAmt || 0;
  headerAllocatePaymentVO.defEarliestQtrForDrugDtls =
    data?.defEarliestQtrForDrugDtls;
  headerAllocatePaymentVO.checkNotAssociatedWithInvoice =
    data?.checkNotAssociatedWithInvoice;
  headerAllocatePaymentVO.alisComm = data?.alisComm;
  headerAllocatePaymentVO.isURASrc = data?.isURASrc;
  headerAllocatePaymentVO.undoRunNo = 0;
  headerAllocatePaymentVO.ccCommentsExist = 0;
  headerAllocatePaymentVO.undoRowNo = [];
  headerAllocatePaymentVO.defEarliestQtrForDrugDtls =
    data?.defEarliestQtrForDrugDtls;
  tempObj[
    `${headerAllocatePaymentVO.invoiceNum}-${headerAllocatePaymentVO.checkLogNum}`
  ] = headerAllocatePaymentVO;
  const reconciliationNumber = data?.recancilationNumber;
  const originalROSIGrid =
    data.rosiGrid?.length > 0 ? JSON.parse(JSON.stringify(data.rosiGrid)) : [];
  const gridArray = data.rosiGrid?.map((item, rowIndex) => {
    item.id = uuidv4();
    item.isAllowFormatterPaidAmt = false;
    item.isAllowFormatterWithheldInvoiceAmt = false;
    item.isAllowFormatterCcInterestAllocated = false;
    item.isAllowFormatterInvoiceCorrectionAmt = false;
    item.isAllowFormatterAdjustedUnits = false;
    item.isLdblOldCcInterestAllocated = false;
    item.cc = '';
    item.ldblOldCcInterestAllocated = item.ccInterestAllocated
      ? parseFloat(item.ccInterestAllocated)?.toFixed(2)
      : parseFloat(0)?.toFixed(2);
    item.ndc = `${item.ndc}//${uuidv4()}`;
    item.ccInterestOwed = item.ccInterestOwed
      ? parseFloat(item.ccInterestOwed)?.toFixed(2)
      : parseFloat(0)?.toFixed(2);
    item.unitRebateAmt = item.unitRebateAmt
      ? parseFloat(item.unitRebateAmt)?.toFixed(6)
      : parseFloat(0)?.toFixed(6);
    item.ccInterestAllocated = item.ccInterestAllocated
      ? parseFloat(item.ccInterestAllocated)?.toFixed(2)
      : parseFloat(0)?.toFixed(2);
    if (item.adjustedUnitRebateAmt?.toString()?.includes('-90210.44')) {
      item.adjustedUnitRebateAmt = null;
    }
    if (item.adjustedUnits?.toString()?.includes('-90210.44')) {
      item.adjustedUnits = null;
    }
    item.adjustedUnitRebateAmt =
      item.adjustedUnitRebateAmt === null ||
      item.adjustedUnitRebateAmt === '' ||
      isNaN(item.adjustedUnitRebateAmt)
        ? ''
        : parseFloat(item.adjustedUnitRebateAmt)?.toFixed(6);
    item.adjustedUnitRebateAmtUpdate = false;
    item.adjustedUnitRebateAmtIsUpdate = false;

    item.adjustedUnitRebateAmtOld = item.adjustedUnitRebateAmt
      ? parseFloat(item.adjustedUnitRebateAmt)?.toFixed(6)
      : parseFloat(0)?.toFixed(6);
    item.adjustedUnitsIsUpdate = false;
    item.adjustedUnits =
      item.adjustedUnits === null ||
      item.adjustedUnits === '' ||
      item.adjustedUnits?.toString() === '0' ||
      isNaN(item.adjustedUnits)
        ? ''
        : parseFloat(item.adjustedUnits)?.toFixed(3);
    item.isAdjustedUnitsUpdated = false;
    item.disputedUnits = item.disputedUnits
      ? parseFloat(item.disputedUnits)?.toFixed(3)
      : parseFloat(0)?.toFixed(3);
    item.totReimbursedUnits = item.totReimbursedUnits
      ? parseFloat(item.totReimbursedUnits)?.toFixed(3)
      : parseFloat(0)?.toFixed(3);
    item.paidUnits = item.paidUnits
      ? parseFloat(item.paidUnits)?.toFixed(3)
      : parseFloat(0)?.toFixed(3);
    item.disputedUnits = item.disputedUnits
      ? parseFloat(item.disputedUnits)?.toFixed(3)
      : parseFloat(0)?.toFixed(3);
    item.paidAmt = item.paidAmt
      ? parseFloat(item.paidAmt)?.toFixed(2)
      : parseFloat(0)?.toFixed(2);
    item.oldPaidAmount = item.paidAmt
      ? parseFloat(item.paidAmt)?.toFixed(2)
      : parseFloat(0)?.toFixed(2);
    item.isRecordModifiedOrNew = false;
    item.invoiceCorrectionAmt = item.invoiceCorrectionAmt
      ? parseFloat(item.invoiceCorrectionAmt)?.toFixed(2)
      : parseFloat(0)?.toFixed(2);
    item.withheldInvoiceAmt = item.withheldInvoiceAmt
      ? parseFloat(item.withheldInvoiceAmt)?.toFixed(2)
      : parseFloat(0)?.toFixed(2);
    item.rebateAmtInvoice = CalculateRebateAmountInvoice(item);
    // item.amountOwedNdc = CalculateAmountOwedNDC(item);
    item.amountOwedNdc = parseFloat(
      parseFloat(item.rebateAmtInvoice) + parseFloat(item.invoiceCorrectionAmt)
    )?.toFixed(2);
    item.invoiceAmt = item.invoiceAmt
      ? parseFloat(item.invoiceAmt)?.toFixed(2)
      : parseFloat(0)?.toFixed(2);
    if (parseInt(item.interestSettledInd, [0, 1]) === 1) {
      item.ccInterestAllocated = parseFloat(0)?.toFixed(2);
    }
    // set value Paid in Full Ind
    if (
      item?.invRecSeqNum === reconciliationNumber ||
      item?.invRecSeqNum === 0
    ) {
      item.bgColorForPaidInFullInd = '';
    } else {
      item.bgColorForPaidInFullInd =
        item.dqdStatsCd === 'WO' ||
        item.dqdStatsCd === 'FG' ||
        item.dqdStatsCd === 'DB' ||
        item.dqdStatsCd === 'DBK'
          ? '00b300'
          : '12632256';
    }
    if (
      parseFloat(item?.ccOverrideColorDis) >= 0 ||
      item.dqdStatsCd === 'WO' ||
      item.dqdStatsCd === 'FG' ||
      item.dqdStatsCd === 'DB' ||
      item.dqdStatsCd === 'DBK'
    ) {
      item.bgColorForInterestCalc = '00b300';
    } else {
      item.bgColorForInterestCalc = '12632256';
    }

    if (
      item.invRecSeqNum == reconciliationNumber ||
      parseInt(item.invRecSeqNum, [0, 1]) === 0
    ) {
      if (
        parseFloat(item?.ccOverrideColorDis) >= 0 ||
        item.dqdStatsCd === 'WO' ||
        item.dqdStatsCd === 'FG' ||
        item.dqdStatsCd === 'DB' ||
        item.dqdStatsCd === 'DBK'
      ) {
        item.bgColorForNDC = '00b300'; // Green color
        item.bgColor = '00b300';
      } else {
        item.bgColorForNDC = '12632256'; // Grey color
        item.bgColor = '12632256';
      }
    } else {
      item.bgColorForNDC = '11534335'; // yellow color
      if (
        parseFloat(item?.ccOverrideColorDis) >= 0 ||
        item.dqdStatsCd === 'WO' ||
        item.dqdStatsCd === 'FG' ||
        item.dqdStatsCd === 'DB' ||
        item.dqdStatsCd === 'DBK'
      ) {
        item.bgColor = '00b300'; // Green color
      } else {
        item.bgColor = '11534335'; // yellow color
      }
    }
    if (
      parseFloat(item?.ccOverrideColorDis) >= 0 ||
      item.dqdStatsCd === 'WO' ||
      item.dqdStatsCd === 'FG' ||
      item.dqdStatsCd === 'DB' ||
      item.dqdStatsCd === 'DBK'
    ) {
      item.bgColorForURA = '00b300'; // Green color
    } else {
      item.bgColorForURA = '12632256'; // Grey color
    }
    if (item.invRecSeqNum === reconciliationNumber || item.invRecSeqNum === 0) {
      if (parseInt(item.ccPaidInFullInd, [0, 1]) === 1) {
        item.paidFulAmt = item.paidAmt;

        if (
          parseFloat(item?.ccOverrideColorDis) >= 0 ||
          item.dqdStatsCd === 'WO' ||
          item.dqdStatsCd === 'FG' ||
          item.dqdStatsCd === 'DB' ||
          item.dqdStatsCd === 'DBK'
        ) {
          item.bgColorForAdjustedURA = '00b300'; // Green color
          item.bgColorForUnitsAdjustment = '00b300';
          item.bgColorForDisputedUnits = '00b300';
          item.bgColorForUnitsPaid = '00b300';
          item.bgColorForCcAc1 = '00b300';
          item.bgColorForCcAc2 = '00b300';
          item.bgColorForCcAc3 = '00b300';
          item.bgColorForCcDc1 = '00b300';
          item.bgColorForCcDc2 = '00b300';
          item.bgColorForCcDc3 = '00b300';
          item.bgColorForInvoiceCorrectionAmt = '00b300';
          item.bgColorForWithheldInvoiceAmt = '00b300';
          item.bgColorForPaidAmt = '00b300';
        } else {
          item.bgColorForAdjustedURA = '12632256';
          item.bgColorForUnitsAdjustment = '12632256';
          item.bgColorForDisputedUnits = '12632256';
          item.bgColorForUnitsPaid = '12632256';
          item.bgColorForCcAc1 = '12632256';
          item.bgColorForCcAc2 = '12632256';
          item.bgColorForCcAc3 = '12632256';
          item.bgColorForCcDc1 = '12632256';
          item.bgColorForCcDc2 = '12632256';
          item.bgColorForCcDc3 = '12632256';
          item.bgColorForInvoiceCorrectionAmt = '12632256';
          item.bgColorForWithheldInvoiceAmt = '12632256';
          item.bgColorForPaidAmt = '12632256';
        }
      } else if (parseFloat(item?.ccOverrideColorDis) >= 0) {
        item.bgColorForAdjustedURA = '00b300'; // Green color
        item.bgColorForUnitsAdjustment = '00b300';
        item.bgColorForDisputedUnits = '00b300';
        item.bgColorForUnitsPaid = '00b300';
        item.bgColorForCcAc1 = '00b300';
        item.bgColorForCcAc2 = '00b300';
        item.bgColorForCcAc3 = '00b300';
        item.bgColorForCcDc1 = '00b300';
        item.bgColorForCcDc2 = '00b300';
        item.bgColorForCcDc3 = '00b300';
        item.bgColorForInvoiceCorrectionAmt = '00b300';
        item.bgColorForWithheldInvoiceAmt = '00b300';
        item.bgColorForPaidAmt = '00b300';
      } else {
        item.bgColorForAdjustedURA = '';
        item.bgColorForUnitsAdjustment = '';
        item.bgColorForDisputedUnits = '';
        item.bgColorForUnitsPaid = '';
        item.bgColorForCcAc1 = '';
        item.bgColorForCcAc2 = '';
        item.bgColorForCcAc3 = '';
        item.bgColorForCcDc1 = '';
        item.bgColorForCcDc2 = '';
        item.bgColorForCcDc3 = '';
        item.bgColorForInvoiceCorrectionAmt = '';
        item.bgColorForWithheldInvoiceAmt = '';
        item.bgColorForPaidAmt = '';
      }
    } else if (
      parseFloat(item?.ccOverrideColorDis) >= 0 ||
      item.dqdStatsCd === 'WO' ||
      item.dqdStatsCd === 'FG' ||
      item.dqdStatsCd === 'DB' ||
      item.dqdStatsCd === 'DBK'
    ) {
      item.bgColorForAdjustedURA = '00b300'; // Green color
      item.bgColorForUnitsAdjustment = '00b300';
      item.bgColorForDisputedUnits = '00b300';
      item.bgColorForUnitsPaid = '00b300';
      item.bgColorForCcAc1 = '00b300';
      item.bgColorForCcAc2 = '00b300';
      item.bgColorForCcAc3 = '00b300';
      item.bgColorForCcDc1 = '00b300';
      item.bgColorForCcDc2 = '00b300';
      item.bgColorForCcDc3 = '00b300';
      item.bgColorForInvoiceCorrectionAmt = '00b300';
      item.bgColorForWithheldInvoiceAmt = '00b300';
      item.bgColorForPaidAmt = '00b300';
    } else {
      item.bgColorForAdjustedURA = '12632256'; // Grey color
      item.bgColorForUnitsAdjustment = '12632256';
      item.bgColorForDisputedUnits = '12632256';
      item.bgColorForUnitsPaid = '12632256';
      item.bgColorForCcAc1 = '12632256';
      item.bgColorForCcAc2 = '12632256';
      item.bgColorForCcAc3 = '12632256';
      item.bgColorForCcDc1 = '12632256';
      item.bgColorForCcDc2 = '12632256';
      item.bgColorForCcDc3 = '12632256';
      item.bgColorForInvoiceCorrectionAmt = '12632256';
      item.bgColorForWithheldInvoiceAmt = '12632256';
      item.bgColorForPaidAmt = '12632256';
    }

    if (
      parseFloat(item?.ccOverrideColorDis) >= 0 ||
      item.dqdStatsCd === 'WO' ||
      item.dqdStatsCd === 'FG' ||
      item.dqdStatsCd === 'DB' ||
      item.dqdStatsCd === 'DBK'
    ) {
      item.bgColorForUnitInvoiced = '00b300'; // Green color
      item.bgColorForrebateAmtInvoice = '00b300';
    } else {
      item.bgColorForUnitInvoiced = '12632256'; // Grey color
      item.bgColorForrebateAmtInvoice = '12632256';
    }
    if (item.drugSeqNum === newObj[rowIndex - 1]?.drugSeqNum) {
      if (
        parseFloat(item?.ccOverrideColorDis) >= 0 ||
        item.dqdStatsCd === 'WO' ||
        item.dqdStatsCd === 'FG' ||
        item.dqdStatsCd === 'DB' ||
        item.dqdStatsCd === 'DBK'
      ) {
        item.bgColorForAmtOwedNDC = '00b300';
      } else {
        item.bgColorForAmtOwedNDC = '12632256';
      }
    } else if (
      parseFloat(item?.ccOverrideColorDis) >= 0 ||
      item.dqdStatsCd === 'WO' ||
      item.dqdStatsCd === 'FG' ||
      item.dqdStatsCd === 'DB' ||
      item.dqdStatsCd === 'DBK'
    ) {
      item.bgColorForAmtOwedNDC = '00b300';
    } else {
      item.bgColorForAmtOwedNDC = '12632256';
    }
    if (item.statusCd === 'PIF') {
      item.ccPaidInFullInd = 1;
    }

    item.disabledForInterestAllocated = false;
    item.bgColorForInterestAllocated = '';
    return item;
  });
  ROSIGirdRowData[
    `${headerAllocatePaymentVO?.invoiceNum}-${headerAllocatePaymentVO?.checkLogNum}`
  ] = gridArray;
  const duplicateArray = [...gridArray];
  duplicateROSIGridList[
    `${headerAllocatePaymentVO?.invoiceNum}-${headerAllocatePaymentVO?.checkLogNum}`
  ] = JSON.parse(JSON.stringify(duplicateArray));
  dispatch(
    dispatchROSIGridList(
      ROSIGirdRowData,
      headerAllocatePaymentVO.invoiceNum,
      headerAllocatePaymentVO.checkLogNum,
      'getCallCommentAPI'
    )
  );
  let storeData = AllocatePaymentReducer?.deallocateNdcRosi;
  storeData = {
    ...storeData,
    [`${headerAllocatePaymentVO?.invoiceNum}-${headerAllocatePaymentVO?.checkLogNum}`]:
      [],
  };
  dispatch(deallocateNDCStore(storeData));
  dispatch(dispatchDuplicateROSIGridList(duplicateROSIGridList));
  if (
    Object.keys(tempObj).filter((x) => {
      return tempObj[x]?.closeTab;
    }).length > 0
  ) {
    dispatch(dispatchSaveDetailsResponse({}));
  }
  const SummaryGrid = data?.summaryGrid ? data?.summaryGrid : [];
  if (SummaryGrid?.length > 0) {
    let sumTotalIntPaidAmt = 0;
    if (originalROSIGrid?.length > 0) {
      sumTotalIntPaidAmt = calculateTotalSum(
        'ccInterestAllocated',
        originalROSIGrid
      );
      const newOwedAmt = calculateTotalSum('amountOwedNdc', gridArray, true)
        ?.toString()
        ?.replace(',', '')
        .trim();
      SummaryGrid[0].currentPrincipalAmount = `$ ${parseFloat(
        newOwedAmt?.toString()?.replace(',', '').trim()
      )?.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    }
    if (parseFloat(sumTotalIntPaidAmt) > 0) {
      SummaryGrid[0].totalIntSettled = parseFloat(sumTotalIntPaidAmt);
    }
    SummaryGrid[0].addEditIntPaid = false;
    SummaryGrid[0].originalAmtIntPaid = SummaryGrid[0].intPaid;
    SummaryGrid[0].originalTotalIntPaid = SummaryGrid[0].totalIntPaid;
    SummaryGrid[0].orgPrincipalPaid = SummaryGrid[0].principalPaid;
  }
  summaryGirdRowData[
    `${headerAllocatePaymentVO?.invoiceNum}-${headerAllocatePaymentVO?.checkLogNum}`
  ] = SummaryGrid;
  dispatch(
    dispatchSummaryGridList(
      summaryGirdRowData,
      headerAllocatePaymentVO.invoiceNum,
      headerAllocatePaymentVO.checkLogNum
    )
  );
  rsAddValuesData[
    `${headerAllocatePaymentVO?.invoiceNum}-${headerAllocatePaymentVO?.checkLogNum}`
  ] = data?.rsaddValue ? data?.rsaddValue : {};
  dispatch(
    dispatchRsAddValuesList(
      rsAddValuesData,
      headerAllocatePaymentVO.invoiceNum,
      headerAllocatePaymentVO.checkLogNum
    )
  );
  dispatch(
    dispatchAllocatePaymentHederData(
      tempObj,
      headerAllocatePaymentVO.invoiceNum,
      headerAllocatePaymentVO.checkLogNum
    )
  );

  if (
    !(
      AllocatePaymentReducer?.disabledIntPaidColObjROSI &&
      Object.keys(AllocatePaymentReducer?.disabledIntPaidColObjROSI)?.filter(
        (x) =>
          x?.toString() ===
          `${headerAllocatePaymentVO?.invoiceNum}-${headerAllocatePaymentVO?.checkLogNum}`?.toString()
      )?.length > 0
    )
  ) {
    const newObjROSI = AllocatePaymentReducer?.disabledIntPaidColObjROSI;
    newObjROSI[
      `${headerAllocatePaymentVO?.invoiceNum}-${headerAllocatePaymentVO?.checkLogNum}`
    ] = {
      rosiGridIntPaidColumnDisabled: false,
      summaryGirdIntPaidColumnDisabled: false,
      isSave: false,
    };
    dispatch(setDisabledValIntPaid(newObjROSI));
  }

  if (cancelPqasFlag && cancelPqasFlag?.pgQtrVal) {
    // API triggger for PQAS Tab
    //  dispatch(dispatchPQASGridLevelActions({ ...newData }));
    onLoadPqasGrid([], headerAllocatePaymentVO, cancelPqasFlag, dispatch);
  } else {
    // save pqas qtr val for pagination
    const request = {
      idecInvoiceNum: headerAllocatePaymentVO.invoiceNum,
      abNext: false,
      isPrevQTR: handleQuarterFormate(headerAllocatePaymentVO.qtr),
    };
    let getQtr;
    if (currPreNxtQtr) {
      getQtr = currPreNxtQtr;
    } else {
      getQtr = await dispatch(getPrevNextQtrForPQAS(request)); // check and call prev qtr value
    }
    let previousQtr = null;
    if (getQtr) {
      dispatch(dispatchGetInvoiceHeader([]));
      previousQtr = getQtr;
      // previousQtr = decrementIncrementQtr(
      // handleQuarterFormate(headerAllocatePaymentVO.qtr),
      //   0
      // );
      const pqasGridLevelActions = {
        pgQtrVal: previousQtr,
        prevNextRecord: false,
        prevNextVal: null,
      };
      const newData = {
        [`${headerAllocatePaymentVO.invoiceNum}-${headerAllocatePaymentVO.checkLogNum}`]:
          pqasGridLevelActions,
      };
      dispatch(dispatchPQASGridLevelActions({ ...newData }));

      // API triggger for PQAS Tab
      onLoadPqasGrid(
        [],
        headerAllocatePaymentVO,
        pqasGridLevelActions,
        dispatch
      );
    }
  }

  searchPicInvAssociationScreenTab[
    `${headerAllocatePaymentVO.invoiceNum}-${headerAllocatePaymentVO.checkLogNum}`
  ] = searchPickInvAssociateScreenObj;
  dispatch(setPerviousSearchPickInvReduxData(searchPicInvAssociationScreenTab));
  invoiceType != 'displayInvoice' &&
    tabHighLigther('/pickInvoiceAssociateWithCheck', false);
  const invoiceNum = headerAllocatePaymentVO?.invoiceNum;
  const navTo = `/allocatePaymentDetail/${checkLogNum}-${invoiceNum}`;
  if (
    updateTabs?.findIndex((item) => {
      // console.log('test', item.navTo, navTo, invoiceNum);
      return item.navTo === navTo;
    }) === -1
  ) {
    if (
      updateTabs?.filter((x) => x.checkLogNum === checkLogNum && !x?.closeTab)
        ?.length > 0 &&
      updateTabs?.filter((x) => x.invoiceNum !== invoiceNum)?.length > 0
    ) {
      updateTabs.map((item) => {
        if (item.checkLogNum === checkLogNum) {
          item.isAlreadyExistCheck = true;
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
      newObj.splice(newObj?.length - 1, 1);
      dispatch(dispatchActiveInvoiceNumber(newObj));
      await clearReduxAllocatePaymentThirdScreen(
        invoiceNum,
        checkLogNum,
        history
      );
      // setTimeout(() => {
      //   redirectURLLink(
      //     updateTabs?.filter((x) => x.isAlreadyExistCheck)[0].navTo,
      //     updateTabs?.filter((x) => x.isAlreadyExistCheck)[0].value,
      //     history
      //   );
      // }, 100);

      // updateTabs = updateTabs?.filter((item) => !item.isAlreadyExistCheck);
      // console.log('updateTabs', updateTabs);
      // updateTabs.push({
      //   navTo: navTo,
      //   value: `ROSI/PQAS[${headerAllocatePaymentVO?.mfgId} abc Inv #:${invoiceNum} Chk Log #: ${checkLogNum}]`,
      //   checkLogNum: checkLogNum,
      //   invoiceNum: invoiceNum,
      //   isAlreadyExistCheck: true,
      //   isAlreadyExistInvoiceNum: false,
      // });
      // localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
      // const alreadyExistCheck = updateTabs?.find((x) => x.isAlreadyExistCheck);
      const alreadyExistCheck = updateTabs.find(
        (x) => x.checkLogNum === checkLogNum && !x.closeTab
      );
      if (alreadyExistCheck) {
        redirectURLLink(
          alreadyExistCheck.navTo,
          alreadyExistCheck.value,
          history
        );
      }
      return;
    } else if (
      updateTabs?.filter((x) => x.invoiceNum === invoiceNum)?.length > 0 &&
      updateTabs?.filter((x) => x.checkLogNum !== checkLogNum)?.length > 0
    ) {
      updateTabs.map((item) => {
        if (item.invoiceNum === invoiceNum) {
          item.isAlreadyExistInvoiceNum = true;
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
      newObj[newObj?.length - 1].active = false;
      newObj[newObj?.length - 1].navTo = navTo;
      newObj[newObj?.length - 1].perviousNavTo =
        invoiceType != 'displayInvoice'
          ? updateTabs?.filter((x) => x.isAlreadyExistInvoiceNum)[0].navTo
          : navTo;
      newObj[newObj?.length - 1].perviousNavValue =
        invoiceType != 'displayInvoice'
          ? updateTabs?.filter((x) => x.isAlreadyExistInvoiceNum)[0].value
          : `ROSI/PQAS[${headerAllocatePaymentVO?.mfgId} Inv #:${invoiceNum} Chk Log #: ${checkLogNum}]`;
      newObj[
        newObj?.length - 1
      ].value = `ROSI/PQAS[${headerAllocatePaymentVO?.mfgId} Inv #:${invoiceNum} Chk Log #: ${checkLogNum}]`;
      await dispatch(dispatchActiveInvoiceNumber(newObj));
      // console.log('Executed post task>Pick search asso details');
      if (invoiceType != 'displayInvoice') {
        redirectURLLink(
          '/pickInvoiceAssociateWithCheck',
          `Pick an Invoice to Associate with this Check (${checkLogNum})`,
          history
        );
      }
    } else {
      updateTabs.push({
        navTo: navTo,
        value: `ROSI/PQAS[${headerAllocatePaymentVO?.mfgId} Inv #:${invoiceNum} Chk Log #: ${checkLogNum}]`,
        checkLogNum: checkLogNum,
        invoiceNum: invoiceNum,
        isAlreadyExistCheck: false,
        isAlreadyExistInvoiceNum: false,
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    }
  }
  if (history) {
    if (invoiceType == 'displayInvoice') {
      const updateTabs =
        JSON.parse(localStorage.getItem('tabItemsData')) === null
          ? []
          : JSON.parse(localStorage.getItem('tabItemsData'));
      updateTabs.map((item) => {
        if (item.isAlreadyExistInvoiceNum) {
          item.navTo = navTo;
          item.value = `ROSI/PQAS[${headerAllocatePaymentVO?.mfgId} Inv #:${invoiceNum} Chk Log #: ${checkLogNum}]`;
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));

      history.push({ pathname: navTo });
    } else {
      history.push({ pathname: navTo });
    }
  }

  // setTimeout(() => {
  // console.log('executes clearingRedux');
  if (tempObj) {
    Object.keys(tempObj).forEach((prop) => {
      if (tempObj[prop]?.closeTab) {
        dispatch(
          clearReduxAllocatePaymentThirdScreen(
            tempObj[prop]?.invoiceNum,
            tempObj[prop]?.checkLogNum
          )
        );
      }
    });
  }

  //  }, 1000);
};
export const removeWhiteSpaceForNDC = (val) => {
  return val?.toString()?.split('//')[0];
};
export const replaceCommaIntoWhiteSpace = (val) => {
  return val?.toString()?.replace(/\,/g, '');
};
export const replaceHyphenWithZero = (val) => {
  if (val === null || val === undefined) return val;
  const strVal = val.toString().trim();
  if (strVal === '-') {
    return '0.00';
  }
  // return original value
  return strVal;
};
// check NDC is modified or not
const hasNDCObjChanged = (obj1, obj2, isRemoveIntSet) => {
  let fieldsToCompare = [
    'interestSettledInd',
    'ccInterestAllocated',
    'ccPaidInFullInd',
    'adjustedUnitRebateAmt',
    'totReimbursedUnits',
    'adjustedUnits',
    'disputedUnits',
    'paidUnits',
    'ccAc1',
    'ccAc2',
    'ccAc3',
    'ccDc1',
    'ccDc2',
    'ccDc3',
    'invoiceCorrectionAmt',
    'withheldInvoiceAmt',
    'paidAmt',
  ];
  if (isRemoveIntSet) {
    fieldsToCompare = fieldsToCompare.filter(
      (field) => field !== 'interestSettledInd'
    );
  }
  const specialFields = new Set([
    'ccAc1',
    'ccAc2',
    'ccAc3',
    'ccDc1',
    'ccDc2',
    'ccDc3',
  ]);

  return fieldsToCompare.some((field) => {
    const val1 = obj1[field];
    const val2 = obj2[field];

    if (specialFields.has(field)) {
      const normalized1 =
        val1 === null || parseFloat(val1) === -1 ? null : parseFloat(val1);
      const normalized2 =
        val2 === null || parseFloat(val2) === -1 ? null : parseFloat(val2);

      return normalized1 !== normalized2;
    } else {
      const num1 = parseFloat(val1);
      const num2 = parseFloat(val2);
      const bothInvalid = isNaN(num1) && isNaN(num2);
      const bothValidAndEqual = !isNaN(num1) && !isNaN(num2) && num1 === num2;
      return !(bothInvalid || bothValidAndEqual);
    }
  });
};

// to check isRosiTabModified
export const isRosiColModifed = (obj1, obj2, isRemoveIntSet = false) => {
  const returnValue = hasNDCObjChanged(obj1, obj2, isRemoveIntSet);
  return returnValue;
};
